const state = {
  orderDetail: {
    insOrderId: '684470511484289024',
    parentPhone: '13360622083',
    studentName: '开发环境学生2',
    studentId: '683719125822078976',
    gradeClassName: '一年级1班',
    paySts: 1,
    payType: 2,
    payNo: null,
    ordFee: '0',
    chargeFee: '0',
    createTime: '2022-03-04 18:41:26',
    channelType: 2,
    payerId: '683716073845174272',
    schoolName: '开发环境林测试学校',
    yearTermName: '2021-2022学年 第2学期',
    courseId: '684345322343759873',
    courseName: '测试圈定范围',
    courseTypeAttr: 1,
    classroomTotal: 10,
    paySts2: null,
    payBeginTime: '2022-03-04 18:41:26',
    payEndTime: '2022-03-04 19:11:26',
    classType: 1,
    payTime: '2022-03-04 18:41:28',
    studentClassTimeTotal: 10,
    studentUsedClassTime: 0,
    studentWaitUsedClassTime: 10,
    classTimeMoney: 0,
    usedClassMoney: 0,
    waitUsedClassMoney: 0,
    acctCode: null,
    agentName: null,
    agentPhone: null,
    userOrderOfferVOList: [
      {
        offerOrderId: '684470511639478272',
        orderId: '684470511484289024',
        offerId: '684345322343759873',
        offerType: 1, // 40材料 1,3-课程
        offerName: '测试圈定范围',
        offerFee: '0',
        relOffOrdId: '0',
        refundReason: null,
        reviewerId: null,
        refundSts: 0,
        classType: 1,
        classroomTotal: 10,
        paySts: null
      },
      {
        offerOrderId: '678195622938939392',
        orderId: '684470511484289024',
        offerId: '684345322343759873',
        offerType: 4, // 40材料 1,3-课程
        offerName: '材料费用',
        offerFee: '0',
        relOffOrdId: '0',
        refundReason: null,
        reviewerId: null,
        refundSts: 0,
        classType: 1,
        classroomTotal: 10,
        paySts: null
      }
    ]
  }, // 订单详情
  attendanceTimes: 0, // 学生考勤次数

  listSignAndTally: {
    // 结算信息
    tallyOrders: {
      '684470511639478272': [
        {
          tallyId: '678237345035800577',
          divideId: '678237344901582849',
          sumAcctNo: '',
          merchantId: '623919002582257664',
          subAcctNo: '12301552369',
          amount: '5333',
          commission: '0',
          ccy: 'RMB',
          sort: 2,
          tallySts: 0,
          stsDate: '2022-02-17 12:37:45',
          status: 1,
          bankSeqNo: '',
          createTime: '2022-02-15 13:53:03',
          operateTime: '2022-02-15 13:53:03',
          statementId: null,
          peerTallyId: null,
          peerDefaceId: null,
          refundDtlId: '0',
          refundRecId: null,
          firstPart: '0',
          refundPaymentId: null,
          tallyType: 0
        },
        {
          tallyId: '678237345035800577',
          divideId: '678237344901582849',
          sumAcctNo: '',
          merchantId: '623919002582257664',
          subAcctNo: '12301552369',
          amount: '5333',
          commission: '0',
          ccy: 'RMB',
          sort: 2,
          tallySts: 0,
          stsDate: '2022-02-17 12:37:45',
          status: 1,
          bankSeqNo: '',
          createTime: '2022-02-15 13:53:03',
          operateTime: '2022-02-15 13:53:03',
          statementId: null,
          peerTallyId: null,
          peerDefaceId: null,
          refundDtlId: '0',
          refundRecId: null,
          firstPart: '0',
          refundPaymentId: null,
          tallyType: 0
        },
        {
          tallyId: '678237345035800577',
          divideId: '678237344901582849',
          sumAcctNo: '',
          merchantId: '623919002582257664',
          subAcctNo: '12301552369',
          amount: '5333',
          commission: '0',
          ccy: 'RMB',
          sort: 2,
          tallySts: 0,
          stsDate: '2022-02-17 12:37:45',
          status: 1,
          bankSeqNo: '',
          createTime: '2022-02-15 13:53:03',
          operateTime: '2022-02-15 13:53:03',
          statementId: null,
          peerTallyId: null,
          peerDefaceId: null,
          refundDtlId: '0',
          refundRecId: null,
          firstPart: '0',
          refundPaymentId: null,
          tallyType: 0
        }
      ],
      '678195622938939392': [{}]
    },
    // 签到信息
    classroomSigns: [
      {
        id: '684102031706841089', // 唯一id
        classroomId: '684102031471960065', // 课堂id
        classId: '683715840352448513', // 学生行政班级
        detailId: '684102031564234753', // 课堂详情id
        identity: 2, // 1老师2学生
        signPersonId: '683719216624562177', // 学生id
        signTime: null, // 签到的时间
        signoutTime: null, // 签退的时间
        reviewTeaher: '0', // 审核老师id
        reviewTeaherName: '', // 审核老师
        leaveTime: null, // 请假时间
        reviewTime: null, // 审核时间
        leaveState: 0, // 请假状态
        temperature: '', // 体温
        signState: 0, // 课班详情表状态
        status: 1, // 1有效0无效
        classTimeBegin: '2022-03-22 11:00:00', // 开始时间
        classTimeEnd: '2022-03-22 12:00:00', // 结束时间
        classroomStudentId: null // 报名表id
      },
      {
        id: '684102031706841088', // 唯一id
        classroomId: '684102031471960065', // 课堂id
        classId: '683715840352448513', // 学生行政班级
        detailId: '684102031564234753', // 课堂详情id
        identity: 2, // 1老师2学生
        signPersonId: '683719216624562177', // 学生id
        signTime: null, // 签到的时间
        signoutTime: null, // 签退的时间
        reviewTeaher: '0', // 审核老师id
        reviewTeaherName: '', // 审核老师
        leaveTime: null, // 请假时间
        reviewTime: null, // 审核时间
        leaveState: 0, // 请假状态
        temperature: '', // 体温
        signState: 0, // 课班详情表状态
        status: 1, // 1有效0无效
        classTimeBegin: '2022-03-22 11:00:00', // 开始时间
        classTimeEnd: '2022-03-22 12:00:00', // 结束时间
        classroomStudentId: null // 报名表id
      },
      {
        id: '684102031706841079', // 唯一id
        classroomId: '684102031471960065', // 课堂id
        classId: '683715840352448513', // 学生行政班级
        detailId: '684102031564234753', // 课堂详情id
        identity: 2, // 1老师2学生
        signPersonId: '683719216624562177', // 学生id
        signTime: null, // 签到的时间
        signoutTime: null, // 签退的时间
        reviewTeaher: '0', // 审核老师id
        reviewTeaherName: '', // 审核老师
        leaveTime: null, // 请假时间
        reviewTime: null, // 审核时间
        leaveState: 0, // 请假状态
        temperature: '', // 体温
        signState: 0, // 课班详情表状态
        status: 1, // 1有效0无效
        classTimeBegin: '2022-03-22 11:00:00', // 开始时间
        classTimeEnd: '2022-03-22 12:00:00', // 结束时间
        classroomStudentId: null // 报名表id
      }
    ]
  }
};

export default state;
